import { render } from "./ShootingPage.vue?vue&type=template&id=80f0c55c&scoped=true"
import script from "./ShootingPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./ShootingPage.vue?vue&type=script&scoped=true&lang=js"

import "./ShootingPage.vue?vue&type=style&index=0&id=80f0c55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f0c55c"]])

export default __exports__